import { render, staticRenderFns } from "./QuoteDetailList.vue?vue&type=template&id=4684b673&"
import script from "./QuoteDetailList.vue?vue&type=script&lang=js&"
export * from "./QuoteDetailList.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDetailList.vue?vue&type=style&index=0&id=4684b673&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports